import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery, baseQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { LoginRequest, LoginResponse } from "../../models/dtos";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQuery("authentication"),
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    login: builder.mutation<ApiResponse<LoginResponse>, LoginRequest>({
      query: (body) => ({
        url: "login",
        method: "POST",
        body,
      }),
    }),
  }),
});
